import { type PhaseCompleteRules } from './phase-complete-rules';
import { type Phase } from './context/phase/entity';

export class PhaseValidator<T> {
    constructor(
        private rules: PhaseCompleteRules<T>,
        private traData: T,
    ) {}

    getCompleteErrors(phase?: Phase): string[] | null {
        if (!phase) {
            return null;
        }
        if (!phase.name) {
            return ['[internal] Phase has no name'];
        }
        const rule = this.rules[phase.name];
        if (typeof rule !== 'function') {
            return ['[internal] Phase has no rule'];
        }
        return rule(this.traData);
    }
}
